import React from 'react';
import PropTypes from 'prop-types';
import './itemListCard.css';

class ItemListCard extends React.Component {
  render() {
    const image = this.props.thumb;
    const price = this.props.priceRange;
    const card = (
      <div className='item-container'>
        <div className='item' onClick={this.props.select}>
          <img src={process.env.PUBLIC_URL + image} alt={this.props.altText} className='product'></img>
          <div className='content'>
            <span className='price'>{price}</span>
            <span className='title'>{this.props.name}</span>
          </div>
        </div>
      </div>
    );

    return card;
  }
}

ItemListCard.propTypes = {
  altText: PropTypes.string.isRequired,
  thumb: PropTypes.string.isRequired,
  priceRange: PropTypes.string.isRequired,
  select: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  showDetails: PropTypes.bool
};

export default ItemListCard;


// WEBPACK FOOTER //
// ./src/components/item/itemListCard/itemListCard.js